
<zxing-scanner [formats]="allowedFormats"

  >
</zxing-scanner>